package music.jammers.shared.auth.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class Token(
    val value: String,
)